<template>
  <div>
      微信绑定
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>